import { ChangeDetectionStrategy, Component, signal, ChangeDetectorRef } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { Constants } from '../../../../shared/utils/constants';

@Component({
  selector: 'app-mitigation-checkbox-header',
  templateUrl: './mitigation-checkbox-header.component.html',
  styleUrls: ['./mitigation-checkbox-header.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MitigationCheckboxHeaderComponent implements IHeaderAngularComp {
  displayName = signal<string>('');
  checked = signal<boolean>(false);
  parent: any;
  field: string = '';
  disabled: boolean = true;
  params: any;

  constructor(private cdr: ChangeDetectorRef) { }

  agInit(params: any): void {
    this.field = params.column.getColDef().field || '';
    this.parent = params.context;
    this.params = params;
    this.displayName.set(params.displayName);
    params.api.addEventListener('checkboxChanged', () => {
      this.checked.set(this.areAllMitigationFieldsSelected());
      this.cdr.detectChanges();
    });
  }

  areAllMitigationFieldsSelected(): boolean {
    return this.parent.rowData.every((element: any) => element[this.field]);
  }

  refresh(params: IHeaderParams) {
    this.displayName.set(params.displayName);
    this.checked.set(this.areAllMitigationFieldsSelected());
    return true;
  }

  onChange(event: any) {
    this.parent.onChangeAllMitigationSelection({ field: this.field, value: event.checked, rowData: this.parent.rowData });
  }

  isDisabled() {
    return !this.params.isProjectOwnershipValid;
  }

}
